import React, { useEffect } from "react";
import { Modal, Form, Input } from "antd";

interface CreateFolderModalProps {
  onCancel: () => void;
  onSubmit: (values: { name: string }) => void;
  isOpen: boolean;
  submitLoading: boolean;
  folderName: string | undefined;
}

const CreateFolderModal: React.FC<CreateFolderModalProps> = ({ isOpen, folderName, onCancel, onSubmit, submitLoading }) => {
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (error) {
      console.error("Validation Failed:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  return (
    <Modal
      title={folderName ? "Edit folder" : "Create Folder"}
      open={isOpen}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okButtonProps={{ loading: submitLoading }}
      okText={folderName ? "Update" : "Create"}
    >
      <Form form={form} layout="vertical" name="createFolderForm" initialValues={{ name: folderName || "" }}>
        <Form.Item
          label="Folder Name"
          name="name"
          rules={[
            { required: true, message: "Please enter a folder name" },
            { max: 50, message: "Name can not exceed 50 characters" },
          ]}
        >
          <Input placeholder="Enter folder name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateFolderModal;
